import * as React from 'react';

import { cn } from '@/utils/styles';

const TableHead = React.forwardRef<HTMLTableCellElement, React.ThHTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...props }, ref) => (
    <th
      ref={ref}
      className={cn(
        'bg-transparent p-2 text-left align-middle text-sm font-medium leading-none text-text-secondary [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...props}
    />
  ),
);

TableHead.displayName = 'TableHead';

export { TableHead };
